/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Table component
 *
 * @author Thais Watanabe
 */
const Table = (props) => {
  return (
    <div className="md:overflow-visible overflow-x-auto">
      <table id={props.id} className="min-w-full divide-y divide-gray-200">
        {props.children}
      </table>
    </div>
  );
};

/**
 * ColHeader
 * @param {*} props
 */
const ColHeader = (props) => {
  return (
    <th
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      scope="col"
      className={`${props.className} px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider`}
    >
      {props.children}
    </th>
  );
};

/**
 * Col
 * @param {*} props
 */
const Col = (props) => {
  return (
    <td
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      className={`${props.className} px-6 py-4 text-sm text-gray-500`}
    >
      {props.children}
    </td>
  );
};

/**
 * TableBody
 * @param {*} props 
 */
const TableBody = (props) => {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
      {props.children}
    </tbody>
  );
};

export { Table, ColHeader, TableBody, Col };
